import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/styles";

import DupontCheckbox from "components/DupontCheckbox";

const useStyles = makeStyles(() => ({
  checkboxContainer: {
    display: "inline-block",
    marginTop: "5px"
  }
}));

const ChartTagHeaderCheckboxRenderer = props => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(false);
  const [isIndeterminate, setIndeterminate] = useState(false);
  const { displayName, api } = props;
  const selectedRowsCount = api.getSelectedRows().length;
  useEffect(() => {
    const rowData = [];
    api.forEachNodeAfterFilterAndSort(node => rowData.push(node.data));
    if (selectedRowsCount === 0) {
      setIsChecked(false);
      setIndeterminate(false);
    } else {
      setIsChecked(rowData.length === selectedRowsCount);
      setIndeterminate(rowData.length !== selectedRowsCount);
    }
  }, [selectedRowsCount]);

  const selectionChangeHandler = val => {
    if (val) {
      api.selectAllFiltered();
    } else {
      api.deselectAllFiltered();
    }
  };

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox
        name={displayName}
        customClass={"checkbox--label"}
        indeterminate={isIndeterminate}
        checked={isChecked}
        labelText={displayName}
        onChange={selectionChangeHandler}
      />
    </span>
  );
};

export default ChartTagHeaderCheckboxRenderer;
